export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12895.d4a0d230.jpg";